import { render, staticRenderFns } from "./SizeSpinner.vue?vue&type=template&id=3adcf89b"
import script from "./SizeSpinner.vue?vue&type=script&lang=js"
export * from "./SizeSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports